import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Box,
  TextField,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const EmployeePaymentsTable = () => {
  const [payslips, setPayslips] = useState([]);
  const [loading, setLoading] = useState(false);
    const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const currentMonthIndex = new Date().getMonth(); 

  const [month, setMonth] = useState(months[currentMonthIndex]);
  const [year, setYear] = useState(new Date().getFullYear());

  // ✅ Dialog state
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [actualPaid, setActualPaid] = useState("");

  // ✅ Months dropdown


  // ✅ Generate years: last 4 years + current + next year
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = currentYear - 4; y <= currentYear + 1; y++) {
    years.push(y);
  }

  useEffect(() => {
    fetchPayslips();
  }, []);

  const fetchPayslips = async () => {
    try {
      setLoading(true);
       const token = localStorage.getItem("token");
        const payload = JSON.parse(atob(token.split('.')[1]));
        const company_id = payload.company_id;
      const response = await axios.get(
        `${API_URL}/api/emp-payment/all?month=${month}&year=${year}`,{
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"  
        },
        withCredentials: true
      }
      );

      if (response.data.success) {
        setPayslips(response.data.data);
      } else {
        setPayslips([]);
      }
    } catch (error) {
      //console.error("Error fetching payslips:", error);
      setPayslips([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handle Add Actual Payment Click
  const handleOpenDialog = (payslip) => {
    setSelectedEmployee(payslip);
    setActualPaid("");
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedEmployee(null);
    setActualPaid("");
  };

  // ✅ Save Actual Paid Salary
const handleSaveActualPayment = async () => {
  if (!selectedEmployee || !actualPaid) return;

  try {
    setLoading(true);

    const payload = {
      employee_id: selectedEmployee.employee_id,
      company_id: selectedEmployee.company_id || 1, // 🔹 If you don’t have company_id yet, pass 1 or from context
      month: selectedEmployee.month,
      year: selectedEmployee.year,
      actual_paid_salary: Number(actualPaid),
      remarks: selectedEmployee.remarks || "Payment recorded manually",
    };
 const token = localStorage.getItem("token");
        const payloadtoken = JSON.parse(atob(token.split('.')[1]));
        const company_id = payloadtoken.company_id;
    const response = await axios.post(
      `${API_URL}/api/emp-payment`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    if (response.data.success) {
      alert(response.data.message);

      // 🔹 If arrear generated, show info
      if (response.data.arrear_flag) {
        alert(
          `Arrear generated for ₹${response.data.arrear_amount.toLocaleString()}`
        );
      }

      fetchPayslips(); // Refresh table
      handleCloseDialog();
    } else {
      alert("Failed to save payment.");
    }
  } catch (error) {
    //console.error("Error saving payment:", error);
    alert("Error saving payment. Check console for details.");
  } finally {
    setLoading(false);
  }
};


  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
        Employee Payslips – {month} {year}
      </Typography>

      {/* Month & Year Filters */}
      <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
        <TextField
          select
          label="Select Month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
          sx={{ width: 200 }}
        >
          {months.map((m) => (
            <MenuItem key={m} value={m}>
              {m}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          label="Select Year"
          value={year}
          onChange={(e) => setYear(Number(e.target.value))}
          sx={{ width: 150 }}
        >
          {years.map((y) => (
            <MenuItem key={y} value={y}>
              {y}
            </MenuItem>
          ))}
        </TextField>

        <Button variant="contained" onClick={fetchPayslips} sx={{ alignSelf: "center" }}>
          Fetch Payslips
        </Button>
      </Box>

      {/* Table Display */}
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3 }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
              <TableRow>
                <TableCell><strong>Employee ID</strong></TableCell>
                <TableCell><strong>Employee Details</strong></TableCell>
                <TableCell><strong>Month & Year</strong></TableCell>
                <TableCell align="right"><strong>Gross Salary</strong></TableCell>
                <TableCell align="right"><strong>Total Deductions</strong></TableCell>
                <TableCell align="right"><strong>Additionals</strong></TableCell>
                <TableCell align="right"><strong>Net Salary</strong></TableCell>
                <TableCell align="right"><strong>Actual Paid</strong></TableCell>
                <TableCell align="right"><strong>Difference</strong></TableCell>
                <TableCell><strong>Status</strong></TableCell>
                <TableCell><strong>Remarks</strong></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {payslips.length > 0 ? (
                payslips.map((payslip) => (
                  <TableRow key={payslip.id}>
                    <TableCell>{payslip.employee_id}</TableCell>
                    <TableCell>
                      {payslip.employee_name} <br />
                      <Typography variant="body2" color="textSecondary">
                        {payslip.employee_email}
                      </Typography>
                    </TableCell>
                    <TableCell>{payslip.month} {payslip.year}</TableCell>
                    <TableCell align="right">{payslip.gross_salary.toLocaleString()}</TableCell>
                    <TableCell align="right">{payslip.total_deductions.toLocaleString()}</TableCell>
                    <TableCell align="right">{payslip.additionals.toLocaleString()}</TableCell>
                    <TableCell align="right">{payslip.net_salary.toLocaleString()}</TableCell>

                    <TableCell align="right">
                      {payslip.actual_paid_salary ? (
                        payslip.actual_paid_salary.toLocaleString()
                      ) : (
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => handleOpenDialog(payslip)}
                        >
                          Add Payment
                        </Button>
                      )}
                    </TableCell>

                    <TableCell align="right">
                      {payslip.difference ? payslip.difference.toLocaleString() : "-"}
                    </TableCell>

                    <TableCell>
                      <Typography
                        variant="body2"
                        sx={{
                          color:
                            payslip.status === "paid"
                              ? "green"
                              : payslip.status === "pending"
                              ? "orange"
                              : "blue",
                          fontWeight: 600,
                        }}
                      >
                        {payslip.status}
                      </Typography>
                    </TableCell>

                    <TableCell>{payslip.remarks || "-"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    No payslips found for {month} {year}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

    {/* ✅ Add Actual Payment Dialog */}
<Dialog open={openDialog} onClose={handleCloseDialog}>
  <DialogTitle>Add Actual Payment</DialogTitle>
  <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
    <Typography>
      <strong>Employee:</strong> {selectedEmployee?.employee_name} ({selectedEmployee?.employee_id})
    </Typography>
    <Typography>
      <strong>Expected Salary:</strong> ₹{selectedEmployee?.net_salary?.toLocaleString()}
    </Typography>

    <TextField
      label="Enter Actual Paid Salary"
      type="number"
      value={actualPaid}
      onChange={(e) => setActualPaid(e.target.value)}
      fullWidth
    />

    <Button
      variant="outlined"
      onClick={() => setActualPaid(selectedEmployee?.net_salary)}
      sx={{ mt: 1 }}
    >
      Same as Expected
    </Button>
  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseDialog}>Cancel</Button>
    <Button variant="contained" onClick={handleSaveActualPayment}>
      Save
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default EmployeePaymentsTable;
